import { render, staticRenderFns } from "./gptTranscriptionModal.vue?vue&type=template&id=3018f8d2&"
import script from "./gptTranscriptionModal.vue?vue&type=script&lang=js&"
export * from "./gptTranscriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./gptTranscriptionModal.vue?vue&type=style&index=0&id=3018f8d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports